export default {
  title: 'Rewards',
  points_balance: 'Points Balance',
  lifetime_earned: 'Total Earned',
  lifetime_redeemed: 'Total Redeemed',
  points_unit: 'pts',
  my_qr: 'My QR Code',
  view_catalog: 'Redeem Rewards',
  view_history: 'Redemption History',
  no_coupons: 'No active campaigns right now',
  no_coupons_sub: 'Earn points by scanning your QR at partner shops.',
  campaign_qr: 'Scan to Earn Points',
  qr_expires_in: 'Refreshes in {{seconds}}s',
  qr_refreshing: 'Refreshing...',
  select_campaign: 'Select Campaign',
  catalog_title: 'Redeem Rewards',
  no_catalog: 'No rewards available right now',
  cost_points: '{{points}} pts',
  thb_value: '฿{{amount}}',
  out_of_stock: 'Out of Stock',
  not_enough_points: 'Not enough points',
  redeem_button: 'Redeem',
  redeem_confirm_title: 'Redeem Reward',
  redeem_confirm_body: 'Redeem "{{name}}" for {{points}} pts?',
  redeem_success_title: 'Redeemed!',
  redeem_success_body: 'Your reward "{{name}}" has been redeemed.',
  fulfillment_ref: 'Reference: {{ref}}',
  history_title: 'Redemption History',
  no_history: 'No redemptions yet',
  history_points: '-{{points}} pts',
  consent_title: 'Join Retention Program',
  consent_body:
    'By joining, FlowRent shares only hashed (non-identifiable) data across its network of properties to award you retention credits when you renew. No personal information is shared with third parties.',
  consent_data_shared: 'Only hashed identifiers — never your name, phone, or email.',
  consent_opt_in: 'I agree and want to join',
  consent_already_registered: 'You are already enrolled in the retention program.',
  consent_success: 'Successfully enrolled in the retention program.',
  errors: {
    insufficient_points: 'You do not have enough points for this reward.',
    reward_unavailable: 'This reward is currently unavailable.',
    no_active_lease: 'You need an active lease to redeem rewards.',
    redeem_failed: 'Redemption failed. Please try again.',
    consent_failed: 'Could not save your consent. Please try again.',
  },
}
